<template>
  <div>
    <c-row>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Bootstrap list group</strong>
            <div class="card-header-actions">
              <a
                href="https://coreui.io/vue/docs/components/list-group"
                class="card-header-action"
                rel="noreferrer noopener"
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div>
          </c-card-header>
          <c-card-body>
            <c-list-group>
              <c-list-group-item>Cras justo odio</c-list-group-item>
              <c-list-group-item>Dapibus ac facilisis in</c-list-group-item>
              <c-list-group-item>Morbi leo risus</c-list-group-item>
              <c-list-group-item>Porta ac consectetur ac</c-list-group-item>
              <c-list-group-item>Vestibulum at eros</c-list-group-item>
            </c-list-group>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>List group</strong>
            <small>active items</small>
          </c-card-header>
          <c-card-body>
            <c-list-group>
              <c-list-group-item>Cras justo odio</c-list-group-item>
              <c-list-group-item active>Dapibus ac facilisis in</c-list-group-item>
              <c-list-group-item>Morbi leo risus</c-list-group-item>
              <c-list-group-item>Porta ac consectetur ac</c-list-group-item>
              <c-list-group-item>Vestibulum at eros</c-list-group-item>
            </c-list-group>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>List group</strong>
            <small>disabled items</small>
          </c-card-header>
          <c-card-body>
            <c-list-group>
              <c-list-group-item disabled>Cras justo odio</c-list-group-item>
              <c-list-group-item>Dapibus ac facilisis in</c-list-group-item>
              <c-list-group-item>Morbi leo risus</c-list-group-item>
              <c-list-group-item disabled>Porta ac consectetur ac</c-list-group-item>
              <c-list-group-item>Vestibulum at eros</c-list-group-item>
            </c-list-group>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>List group</strong>
            <small>actionable items</small>
          </c-card-header>
          <c-card-body>
            <c-list-group>
              <c-list-group-item href="#some-link">Awesome link</c-list-group-item>
              <c-list-group-item href="#" active>Link with active state</c-list-group-item>
              <c-list-group-item href="#">Action links are easy</c-list-group-item>
              <c-list-group-item href="#foobar" disabled>Disabled link</c-list-group-item>
            </c-list-group>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>List group</strong>
            <small>buttons</small>
          </c-card-header>
          <c-card-body>
            <c-list-group>
              <c-list-group-item tag="button">Button item</c-list-group-item>
              <c-list-group-item tag="button">I am a button</c-list-group-item>
              <c-list-group-item tag="button" disabled>Disabled button</c-list-group-item>
              <c-list-group-item tag="button">This is a button too</c-list-group-item>
            </c-list-group>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>List group</strong>
            <small>with badges</small>
          </c-card-header>
          <c-card-body>
            <c-list-group>
              <c-list-group-item class="d-flex justify-content-between align-items-center">
                Cras justo odio
                <c-badge color="primary" shape="pill">14</c-badge>
              </c-list-group-item>
              <c-list-group-item class="d-flex justify-content-between align-items-center">
                Dapibus ac facilisis in
                <c-badge color="primary" shape="pill">2</c-badge>
              </c-list-group-item>
              <c-list-group-item class="d-flex justify-content-between align-items-center">
                Morbi leo risus
                <c-badge color="primary" shape="pill">1</c-badge>
              </c-list-group-item>
            </c-list-group>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>List group</strong>
            <small>colors</small>
          </c-card-header>
          <c-card-body>
            <c-list-group>
              <c-list-group-item>This is a default list group item</c-list-group-item>
              <c-list-group-item color="primary">This is a primary list group item</c-list-group-item>
              <c-list-group-item color="secondary">This is a secondary list group item</c-list-group-item>
              <c-list-group-item color="success">This is a success list group item</c-list-group-item>
              <c-list-group-item color="danger">This is a danger list group item</c-list-group-item>
              <c-list-group-item color="warning">This is a warning list group item</c-list-group-item>
              <c-list-group-item color="info">This is a info list group item</c-list-group-item>
              <c-list-group-item color="light">This is a light list group item</c-list-group-item>
              <c-list-group-item color="dark">This is a dark list group item</c-list-group-item>
            </c-list-group>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>List group</strong>
            <small>colors active</small>
          </c-card-header>
          <c-card-body>
            <c-list-group>
              <c-list-group-item href="#">This is a default list group item</c-list-group-item>
              <c-list-group-item href="#" color="primary">This is a primary list group item</c-list-group-item>
              <c-list-group-item href="#" color="secondary">This is a secondary list group item</c-list-group-item>
              <c-list-group-item href="#" color="success">This is a success list group item</c-list-group-item>
              <c-list-group-item href="#" color="danger">This is a danger list group item</c-list-group-item>
              <c-list-group-item href="#" color="warning">This is a warning list group item</c-list-group-item>
              <c-list-group-item href="#" color="info">This is a info list group item</c-list-group-item>
              <c-list-group-item href="#" color="light">This is a light list group item</c-list-group-item>
              <c-list-group-item href="#" color="dark">This is a dark list group item</c-list-group-item>
            </c-list-group>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col col="12">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>List group</strong>
            <small>inside cards</small>
          </c-card-header>
          <c-card-body>
            <c-card-group deck>
              <c-card>
                <c-card-header>
                  <b>Card with list group</b>
                </c-card-header>
                <c-card-body>
                  <c-list-group>
                    <c-list-group-item href="#">Cras justo odio</c-list-group-item>
                    <c-list-group-item href="#">Dapibus ac facilisis in</c-list-group-item>
                    <c-list-group-item href="#">Vestibulum at eros</c-list-group-item>
                  </c-list-group>
                  <c-card-text class="mt-2">
                    Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla tempor. Laborum consequat
                    non elit enim exercitation cillum aliqua consequat id aliqua. Esse ex consectetur mollit voluptate
                    est in duis laboris ad sit ipsum anim Lorem.
                  </c-card-text>
                </c-card-body>
              </c-card>
              <c-card>
                <c-card-header><b>Card with flush list group</b></c-card-header>
                <c-list-group flush>
                  <c-list-group-item href="#">Cras justo odio</c-list-group-item>
                  <c-list-group-item href="#">Dapibus ac facilisis in</c-list-group-item>
                  <c-list-group-item href="#">Vestibulum at eros</c-list-group-item>
                </c-list-group>
                <c-card-body>
                  Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla tempor. Laborum consequat non
                  elit enim exercitation cillum aliqua consequat id aliqua. Esse ex consectetur mollit voluptate est in
                  duis laboris ad sit ipsum anim Lorem.
                </c-card-body>
              </c-card>
            </c-card-group>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>List group</strong>
            <small>custom content</small>
          </c-card-header>
          <c-card-body>
            <c-list-group>
              <c-list-group-item href="#" active class="flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-1">List group item heading</h5>
                  <small>3 days ago</small>
                </div>
                <p class="mb-1">
                  Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.
                </p>
                <small>Donec id elit non mi porta.</small>
              </c-list-group-item>
              <c-list-group-item href="#" class="flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-1">List group item heading</h5>
                  <small class="text-muted">3 days ago</small>
                </div>
                <p class="mb-1">
                  Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.
                </p>
                <small class="text-muted">Donec id elit non mi porta.</small>
              </c-list-group-item>
              <c-list-group-item href="#" disabled class="flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-1">Disabled List group item</h5>
                  <small class="text-muted">3 days ago</small>
                </div>
                <p class="mb-1">
                  Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.
                </p>
                <small class="text-muted">Donec id elit non mi porta.</small>
              </c-list-group-item>
            </c-list-group>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>

<script>
export default {
  name: 'ListGroups',
};
</script>
